export default __webpack_public_path__ + "static/media/back.ca2eb8ae.svg";